<template v-for="transfers in transfersList">
  <div class="parent-container">
    <div class="table table--special-width" @click="showPanel()">
      <div class="table__section table__section--body">
        <!-- table row -->
        <div class="table__row">
          <!-- table data -->
          <div class="table__data table__data--bold">
            <div class="table__data--bold">
              12
            </div>
          </div>
          <!-- table data -->
          <div class="table__data">
            <div class="table__data--default">JR Washington</div>
            <div class="table__data--sub">GTB Bank (****2086))</div>
          </div>
          <!-- table data -->
          <div class="table__data">
            <div class="table__data--default">Today</div>
            <div class="table__data--sub">Oct 23, 2017</div>
          </div>
          
          <!-- table data -->
          <div class="table__data">
            <div class="table__data--default">
              <span class="tag tag--red">Failed</span>
            </div>
          </div>
          
          <!-- table data -->
          <div class="table__data">
            <div class="table__data--default">Sent by: <span class="table__data--result"> Yele </span></div>
          </div>
          
          <!-- table data -->
          
          <div class="table__data" :class="{'inverted': showTransferDetails}">
            <!--if there's more info-->
            <div class="table__data--more-info" v-if="hasMoreInfo"></div>
            <div class="table__data--more-info" v-if="hasMoreInfo"></div>
            <div class="table__data--no-info" v-if="!hasMoreInfo"></div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="panel panel__transfer-details" :class="{'isActive': showTransferDetails}" v-if="hasMoreInfo">
      <div class="panel__content panel__content--grey outer-container">
        <!--transaction information-->
        <div class="transfer-detail__content">
          <div class="transfer-detail__title">Transaction information</div>
          <div class="transfer-detail__item">
            <div class="transfer-detail__item__name">Sent from</div>
            <div class="transfer-detail__item__result">Wallet (USD Balance)</div>
          </div>
          
          <div class="transfer-detail__item">
            <div class="transfer-detail__item__name">Sent by</div>
            <div class="transfer-detail__item__result">Koromone</div>
          </div>
          
          <div class="transfer-detail__item">
            <div class="transfer-detail__item__name">Approved by</div>
            <div class="transfer-detail__item__result">Felix</div>
          </div>
          
          <div class="transfer-detail__item">
            <div class="transfer-detail__item__name">Transaction type</div>
            <div class="transfer-detail__item__result">One-time payment</div>
          </div>
          
          <div class="transfer-detail__item">
            <div class="transfer-detail__item__name">Reference</div>
            <div class="transfer-detail__item__result">Paying my debts</div>
          </div>
          
          <div class="transfer-detail__item transaction-cost">
            <div class="transfer-detail__item__name">Total cost <span>(+incl fees)</span></div>
            <div class="transfer-detail__item__result">$ 12,280,000</div>
          </div>
        </div>
        <div class="transfer-detail__content">
          <div class="transfer-detail__title">Recipient information</div>
          <div class="transfer-detail__item">
            <div class="transfer-detail__item__name">Recipient</div>
            <div class="transfer-detail__item__result">JR Washington</div>
          </div>
          
          <div class="transfer-detail__item">
            <div class="transfer-detail__item__name">Recepient account</div>
            <div class="transfer-detail__item__result">GTB Bank (****2086)</div>
          </div>
          
          <div class="transfer-detail__item">
            <div class="transfer-detail__item__name">Country</div>
            <div class="transfer-detail__item__result">Nigeria (NGN)</div>
          </div>
          
          <div class="transfer-detail__item transaction-cost">
            <div class="transfer-detail__item__name">Amount recieved</div>
            <div class="transfer-detail__item__result">NGN 12,280</div>
          </div>
        </div>
      </div>
    </div>
    <div class="table table--special-width">
      <div class="table__section table__section--body">
        <!-- table row -->
        <div class="table__row spacer"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    
    created(){
      console.log(this.transfersList)
    },
    props: ['transfersList'],
    
    data:function() {
      return {
        showTransferDetails: false,
        selected:false,
        hasMoreInfo:true,
      }
    },
    
    
    components:{
    },
    methods:{
      showPanel:function () {
        this.showTransferDetails = !this.showTransferDetails;
      }
      
    }
  }
</script>
<style lang="scss">
  .panel__transfer-details{
    height:0;
    opacity:0;
    transform:translateY(-5px);
    transition: transform 2s ease-out, opacity 1s ease-out;
    
  }
  .panel__transfer-details.isActive{
    height:auto;
    opacity:1;
    transform:translateY(0);
    transition: transform 1s ease-in, opacity 0.3s ease-in;
  }
  
  .table__data{
    &.inverted{
      .table__data--more-info{
        &:first-of-type{
          transform:rotate(27deg);
        }
        &:nth-of-type(2){
          transform:rotate(-27deg);
        }
    
      }
    }
  }

  
</style>



// WEBPACK FOOTER //
// src/components/transfers/TransferTransaction.vue